import client from '../helpers/HttpClient';
import handleError from '../helpers/error';

class ldapService {    
  async fetch(params) {
    try {      
      const result = await client.get('ldapserver/index', { params });
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async create(obj) {
    try {
      const result = await client.post('ldapserver/create', obj);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async update(id, obj) {
    try {
      const result = await client.post(`ldapserver/update/${id}`, obj);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async test(id, obj) {
    try {
      const result = await client.post(`ldapserver/test/${id}`, obj);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async get(id) {
    try {
      const result = await client.get(`ldapserver/view/${id}`);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async remove(id) {
    try {
      const result = await client.post(`ldapserver/delete/${id}`);
      return result.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
}

export default new ldapService();
